import Vue from 'vue';
import Vuex from 'vuex';
import BackendAPI from '@/utils/backendAPI.js';
import longTerm from './longTerm';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    errorMessage: ''
  },
  mutations: {
    errorMessage: (state, errorMessage) => (state.errorMessage = errorMessage)
  },
  getters: {
    errorMessage: state => state.errorMessage
  },
  actions: {
    async login(_context, userData) {
      const res = await BackendAPI.post('/login', userData);
      return res;
    }
  },
  modules: {
    longTerm
  }
});
